export const isObjectId = (s: string) => {
    // Check if a string is a valid MongoDB ObjectId
    return /^[a-fA-F0-9]{24}$/.test(s)
}
